const dateFormat = {
  methods: {
    $_dateFormat_shortDate(isoDate) {
      return this.$d(getDateObject(isoDate), 'short')
    },
    $_dateFormat_dateWithYear(isoDate) {
      return this.$d(getDateObject(isoDate), 'dateWithYear')
    },
    $_dateFormat_dateWithYearAndTimeInUTC(isoDate) {
      return this.$d(getDateObject(isoDate), 'dateWithYearAndTimeInUTC')
    },
    $_dateFormat_dateWithYearAndWeekday(isoDate) {
      return this.$d(getDateObject(isoDate), 'dateWithYearAndWeekday')
    },
    $_dateFormat_orderBy(dateIso) {
      const cutoffDate = getDateObject(dateIso)
      const now = new Date()
      const isCutoffInPast = cutoffDate.getTime() <= now.getTime()

      const hoursWithMinutes = `${this.$t('dateFormat.by')} ${this.$d(cutoffDate, 'hoursWithMinutes')
        .replace(/\s/g, '')
        .toLowerCase()}`
      const hours = `${this.$t('dateFormat.by')} ${this.$d(cutoffDate, 'hours').replace(/\s/g, '').toLowerCase()}`

      return isCutoffInPast ? this.$t('dateFormat.today') : cutoffDate.getMinutes() ? hoursWithMinutes : hours
    },
    $_dateFormat_deliveryDate({ from: dateFromIso, to: dateToIso }) {
      let expectedDate = ''

      if (dateFromIso && dateToIso) {
        const dateFrom = getDateObject(dateFromIso)
        const dateTo = getDateObject(dateToIso)
        expectedDate = `${this.$d(dateFrom, 'short')} - ${this.$d(dateTo, 'short')}`
      } else if (dateFromIso) {
        const dateFrom = getDateObject(dateFromIso)
        const tomorrow = getDateObject()
        tomorrow.setDate(tomorrow.getDate() + 1)
        const dateFromDMY = `${dateFrom.getDate()} ${dateFrom.getMonth()} ${dateFrom.getFullYear()}`
        const tomorrowDMY = `${tomorrow.getDate()} ${tomorrow.getMonth()} ${tomorrow.getFullYear()}`

        if (dateFromDMY === tomorrowDMY) {
          expectedDate = this.$t('dateFormat.tomorrow')
        } else {
          expectedDate = this.$d(dateFrom, 'short')
        }
      }

      if (this.$i18n.locale === 'de-DE') return expectedDate.replace(/,/g, '')
      return expectedDate
    },
  },
}

function getDateObject(isoDate) {
  let date = isoDate ? new Date(isoDate) : new Date()
  // TODO remove once order APIs returns ISO format dates
  if (!(date instanceof Date && !isNaN(date))) {
    date = new Date(isoDate.replace(/-/g, '/'))
  }

  return date
}

export default dateFormat
